import script from "./PersonBankverbindungComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonBankverbindungComponent.vue?vue&type=script&setup=true&lang=ts"

import "./PersonBankverbindungComponent.vue?vue&type=style&index=0&id=6fcf2c01&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fcf2c01"]])

export default __exports__